import React, { useState } from "react";
import "./BookingList.css";
const BookingList = ({ booking }) => {
  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    return new Date(isoDate).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (isoDate) => {
    if (!isoDate) return "";
    return new Date(isoDate).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  if (!booking.length) {
    return <p className="no-bookings">No bookings found</p>;
  }

  return (
    <>
      <div className="booking-list">
        {booking.map((item, index) => {
          return (
            <div key={item?.id} className="booking-row-wrapper">
              <div className="booking-row static">
                <div className="booking-left">
                  <div className="booking-avatar">
                    <img
                      src={item?.services?.[0]?.image?.image}
                      alt={item?.services?.[0].name}
                    />
                  </div>

                  <div className="booking-info">
                    <h4>{item?.services?.[0].name}</h4>
                    <p className="booking-id">#{item?.id}</p>
                    <small>
                      {formatTime(item?.created_at)} |{" "}
                      {formatDate(item?.created_at)}
                    </small>
                  </div>
                </div>

                <div className="booking-center">
                  <label>Full Name</label>
                  <input type="text" value={item?.user?.name || ""} readOnly />
                </div>
                <div className="booking-center">
                  <label>Gender</label>
                  <input type="text" value={item?.gender || ""} readOnly />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default BookingList;
